<template>
  <div style="background-color: #fafaf5; min-height: 100vh; overflow: scroll">
    <div
      class="top_bg"
      style="background-image: url('img/magicPlace/top_bg.png')"
    >
      <div
        class="go_back_button"
        @click="goBack"
        style="background-image: url('img/magicPlace/back.png')"
      ></div>
    </div>
    <div
      class="bronze_bag_"
      style="background-image: url('img/magicPlace/list_bg.png')"
    >
      <div class="roomNav_">
        <template>
          <div
            v-for="(item, index) in ranklist"
            :key="index"
            class="room-title"
            :style="
              rankCur == index
                ? 'background-image:url(' + item.navAcBg + ')'
                : 'background-image:url(' + item.navBg + ')'
            "
            @click="rankchange(index, item.id)"
          ></div>
        </template>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getInfo"
          offset="10"
        >
          <div class="list_box">
            <div
              class="gift_item_"
              style="background-image: url('img/magicPlace/level_high.png')"
              v-for="(item, index) in listData"
              :key="index"
            >
              <div style="display: flex">
                <img class="send_face" :src="item.head_portrait" alt="" />
                <div class="nickname">{{ item.nickname }}</div>
              </div>
              <div
                style="display: flex; align-items: center; position: relative"
              >
                <div>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div class="gift_name__">{{ item.gift_name }}</div>
                    <div class="gift_num">X{{ item.num }}</div>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      margin-top: 5px;
                    "
                  >
                    <img class="bi" src="img/bi.png" alt="" />
                    <div class="gift_value">
                      {{ item.diamonds * item.num }}
                    </div>
                  </div>
                </div>

                <img class="gift_url" :src="item.gift_url" alt="" />
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
    <script>
import "@/assets/css/magicPlace.css";
import { serverPullMsg } from "@/api/api";
export default {
  data() {
    return {
      listData: [],
      rankCur: 0,
      loading: false,
      finished: false,
      refreshing: false,
      ranklist: [
        {
          name: "QQ糖",
          id: 495,
          cur: 0,
          navBg: "img/magicPlace/one_default.png",
          navAcBg: "img/magicPlace/one_active.png",
          show: false,
        },
        {
          name: "水果糖",
          id: 496,
          cur: 0,
          navBg: "img/magicPlace/two_default.png",
          navAcBg: "img/magicPlace/two_active.png",
          show: false,
        },
        {
          name: "牛扎糖",
          id: 493,
          cur: 0,
          navBg: "img/magicPlace/three_default.png",
          navAcBg: "img/magicPlace/three_active.png",
          show: false,
        },
        {
          name: "太妃糖",
          id: 494,
          cur: 0,
          navBg: "img/magicPlace/four_default.png",
          navAcBg: "img/magicPlace/four_active.png",
          show: false,
        },
      ],
      params: {
        type: 1,
        page: 1,
        rows: 15,
        gift_id: 495,
      },
    };
  },
  created() {},
  methods: {
    rankchange(e, id) {
      this.rankCur = e;
      this.params.page = 1;
      this.params.gift_id = id;
      this.listData = [];
      this.ranklist[e].cur = 0;
      this.getInfo()
    },
    getInfo() {
      serverPullMsg(this.params)
        .then(
          (res) => {
            this.loading = false;
            this.refreshing = false;
            if (this.params.page == 1) {
              this.listData = res.data;
            } else {
              this.listData = this.listData.concat(res.data);
            }
            if (res.data.length < 15) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            console.log(this.listData);
            this.params.page = this.params.page + 1;
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
    onRefresh() {
      this.listData = [];
      this.params.page = 1;
      this.finished = false;
      // this.getInfo();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
